import { useState } from "react";
import { changePassword } from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription, DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export const ChangePasswordButton = () => {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await changePassword(cur, nw);
      toast.success("Password updated");
      setOpen(false); setCur(""); setNw("");
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not change password"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="change-password-btn" title="Change password"
          className="text-white/50 hover:text-white p-1.5 rounded hover:bg-white/5">
          <KeyRound className="h-4 w-4" />
        </button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-display">Change Password</DialogTitle>
          <DialogDescription>Update the password for your account.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <Label className="text-xs uppercase tracking-wide text-muted-foreground">Current Password</Label>
            <Input data-testid="cp-current" type="password" className="mt-1.5 h-9" value={cur} onChange={(e) => setCur(e.target.value)} />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wide text-muted-foreground">New Password (min 8)</Label>
            <Input data-testid="cp-new" type="password" className="mt-1.5 h-9" value={nw} onChange={(e) => setNw(e.target.value)} />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
          <Button data-testid="cp-save" className="bg-[#0055FF] hover:bg-[#0044CC]" disabled={busy || !cur || nw.length < 8} onClick={submit}>
            {busy ? "Saving…" : "Update Password"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
